import { EarthBrainViewerAPIs } from "./EarthBrainViewerAPIs";
/**
 * Public API for spreading/compaction feature.
 * Thin facade delegating to SCDesign methods.
 */
export class SpreadingCompactionAPIs extends EarthBrainViewerAPIs {
    // --- Face Selection ---
    async startFaceSelection(localGeometry, callback) {
        await this._scDesign.startFaceSelection(localGeometry, callback);
    }
    stopFaceSelection() {
        this._scDesign.stopFaceSelection();
    }
    isFaceSelectionActive() {
        return this._scDesign.isFaceSelectionActive();
    }
    setFaceSelectionAngleTolerance(degrees) {
        this._scDesign.setFaceSelectionAngleTolerance(degrees);
    }
    /**
     * `faces` (default): the selection itself. `horizontal`: a horizontal plane at
     * the selection's highest z over the target AABB, drawn while selecting and
     * returned by `getSelectedFaceLocalGeometry`.
     */
    setFaceSelectionBaseMode(mode) {
        this._scDesign.setFaceSelectionBaseMode(mode);
    }
    getFaceSelectionBaseMode() {
        return this._scDesign.getFaceSelectionBaseMode();
    }
    async getSelectedFaceLocalGeometry() {
        return this._scDesign.getSelectedFaceLocalGeometry();
    }
    // --- Terrain extension ---
    /**
     * Extend a Local-space geometry's open boundary vertically down to the terrain.
     * @param interpolationPitch Max XY length (m) of a skirt segment; non-positive disables subdivision.
     */
    extendGeometryToTerrain(geometry, terrainId, terrainType, interpolationPitch) {
        return this._scDesign.extendGeometryToTerrain(geometry, terrainId, terrainType, interpolationPitch);
    }
    // --- Results ---
    async createSpreadingCompaction(spreadingCompactionId, input) {
        await this._scDesign.createSpreadingCompaction(spreadingCompactionId, input);
    }
    clearSpreadingCompaction(spreadingCompactionId) {
        this._scDesign.clearSpreadingCompaction(spreadingCompactionId);
    }
    // --- Visibility ---
    setSpreadingCompactionVisible(spreadingCompactionId, visible) {
        this._scDesign.setSpreadingCompactionVisible(spreadingCompactionId, visible);
    }
    setSpreadingCompactionSurfaceVisible(spreadingCompactionId, type, offset, visible) {
        this._scDesign.setSpreadingCompactionSurfaceVisible(spreadingCompactionId, type, offset, visible);
    }
    setSpreadingCompactionOpacity(spreadingCompactionId, alpha) {
        this._scDesign.setSpreadingCompactionOpacity(spreadingCompactionId, alpha);
    }
    async refreshSpreadingCompactionCrossSection() {
        await this._scDesign.refreshSpreadingCompactionCrossSection();
    }
    // --- Query ---
    hasSpreadingCompaction(spreadingCompactionId) {
        return this._scDesign.hasSpreadingCompaction(spreadingCompactionId);
    }
    getSpreadingCompactionGeometries(spreadingCompactionId) {
        return this._scDesign.getSpreadingCompactionGeometries(spreadingCompactionId);
    }
}
//# sourceMappingURL=spreading-compaction-apis.js.map